import { render, staticRenderFns } from "./layout-topbar.vue?vue&type=template&id=342c0a5e&scoped=true"
import script from "./layout-topbar.vue?vue&type=script&lang=js"
export * from "./layout-topbar.vue?vue&type=script&lang=js"
import style0 from "./layout-topbar.vue?vue&type=style&index=0&id=342c0a5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342c0a5e",
  null
  
)

export default component.exports